import {Platform} from 'react-native';
import FastImage from 'react-native-fast-image';
import {ScrollView} from 'react-native-gesture-handler';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {RFValue} from 'react-native-responsive-fontsize';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';
import {css} from 'styled-components/native';
import styled from 'styled-components/native';

interface ItemName {
  capitalize?: boolean;
}

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled(ScrollView).attrs(() => ({
  contentContainerStyle: {
    paddingBottom: RFValue(24),
  },
}))`
  flex: 1;
`;

export const ContentHeader = styled.View`
  padding: 0 24px;
`;

export const FinesCardWrapper = styled.View`
  padding: 0 24px;
  margin-top: ${RFValue(20)}px;
`;

export const Section = styled.View`
  border-style: solid;
  border-color: ${({theme}) => theme.colors.border2};
  border-bottom-width: 1px;
  padding-bottom: ${RFValue(20)}px;
  margin-bottom: ${RFValue(20)}px;
`;

export const MainItem = styled.View`
  flex-direction: row;
  margin-top: ${RFValue(12)}px;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
`;

export const Icon = styled(FontAwesome5)`
  color: ${({theme}) => theme.colors.primary};
  font-size: ${RFValue(16)}px;
  padding: 8px;
  padding-right: 20px;
`;

export const IconContainer = styled.View`
  /* height: ${RFValue(20)}px; */
  width: ${RFValue(40)}px;
`;

export const FipeArea = styled.View`
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  border-style: dashed;
  border-color: ${({theme}) => theme.colors.border};
  border-width: 3px;
  border-radius: ${RFValue(12)}px;
  padding: ${RFValue(12)}px;
`;

export const Item = styled.View`
  flex-direction: row;
  padding: 0 24px;
  height: ${RFValue(55)}px;
  border-style: solid;
  align-items: center;
  border-color: ${({theme}) => theme.colors.border2};
  border-bottom-width: 1px;
`;

export const ItemContainer = styled.View`
  margin-left: ${RFValue(12)}px;
`;

export const ItemName = styled.Text<ItemName>`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;

  ${({capitalize}) =>
    capitalize &&
    css`
      text-transform: capitalize;
    `}
`;

export const Label = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
`;

export const TitleContainer = styled.View`
  flex-direction: column;
`;

export const LabelFipe = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  justify-content: center;
  align-items: center;
`;
export const LabelTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  flex-wrap: wrap;
  flex-direction: row;
`;

export const ItemFipe = styled.Text<ItemName>`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(14)}px;

  ${({capitalize}) =>
    capitalize &&
    css`
      text-transform: capitalize;
    `}
`;

export const Footer = styled.View`
  padding-bottom: ${Platform.OS === 'ios'
    ? getBottomSpace()
    : RFValue(20)}px;
`;

export const CustomPanel = styled.TouchableOpacity`
  border-radius: ${RFValue(10)}px;
  overflow: hidden;
`;

export const PanelImage = styled(FastImage)`
  width: 100%;
  height: 100%;
`;
